import { trackFetchProfileError } from './newrelic/newRelicTrackingApi';
import {
  createAuthorizationHeaders,
  observableFetchClient,
} from '@vp/common-api-utils';
import { getAuthHeaderAndShopperId } from '@vp/common-api-utils/authHelpers';
import type { IShopperProfile } from '../types/ShopperProfile.types';

const profileBaseUrl = 'https://profile.cimpress.io';

// TODO: find a way to extract this value from tenantConfig
const accountId = 'ozoDdrmewShEcbUDWX8J3V';

export const getProfile = async () => {
  const url = `${profileBaseUrl}/v1/${accountId}/profile/me`;
  try {
    const { authHeader } = getAuthHeaderAndShopperId();
    const response = await observableFetchClient({
      url: url,
      method: 'get',
      headers: createAuthorizationHeaders(authHeader),
    });
    return (await response.json()) as IShopperProfile;
  } catch (err) {
    if (err instanceof Error) {
      trackFetchProfileError(err);
    }
    return undefined;
  }
};
